import { useMemo } from 'react';
import { adminAccess, type AdminAccess } from '@wapharma/domain';
import { useAuth } from '../contexts/AuthContext';

export function useAdminAccess(): AdminAccess {
  const { user } = useAuth();
  const roles = user?.roles ?? [];
  const packs = user?.packs;
  const grants = user?.grants;
  return useMemo(() => adminAccess(packs, roles, grants), [packs, roles, grants]);
}

export function useStaffRoles() {
  const { user } = useAuth();
  const roles = user?.roles ?? [];
  const access = useAdminAccess();

  return useMemo(() => {
    return {
      roles,
      isSuperAdmin: roles.includes('SUPER_ADMIN'),
      canWriteCatalog: access.writeCatalog,
      canWriteInventory: access.writeStock,
      canWriteProcurement: access.writeBuy,
      canWriteAccounting: access.writeMoney,
      canWriteSales: access.writeSell,
      canMutateLeadFlows: false,
      canAccessCrm: access.seeLeads,
      canReindexSearch: access.writeCatalog,
    };
  }, [access, roles]);
}
